import React, { useEffect, useMemo, useState } from 'react'
import { useHistory, Redirect } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid'
import '../CreateProduct.css'
import {
  makeStyles,
  Paper,
  Button,
  CircularProgress,
  Divider,
} from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import { useForm } from 'react-hook-form'
import clsx from 'clsx'
import classNames from 'classnames'
import mapValues from 'lodash/mapValues'
import CustomAlert from '../../CustomAlert'
import CheckUserProvider from '../../../AllHooks/CheckUserProvider'
import { Helmet } from 'react-helmet'
import db from '../../../Backend/firebase/firebase'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { debounce } from 'lodash'
import { loadAllMedicine } from '../../../mock/common'

const useStyles = makeStyles((theme) => ({
  root: {},
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'initial',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: '100%',
    padding: '20px',
  },
}))

function CreateChemistOrder() {
  const { register, handleSubmit, errors, reset, setValue } = useForm()
  const classes = useStyles()
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight)
  const [openNotify, setOpenNotify] = React.useState(false)
  const [notificationMessage, setNotificationMessage] = useState('')
  const [alertType, setAlertType] = useState('')
  const [previewState, setPreviewState] = useState({})
  const [isPreview, setIsPreview] = useState(false)
  const history = useHistory()
  const [isLoading, setIsLoading] = useState(false)
  const { userData } = CheckUserProvider()
  const [ProductEntry, setProductEntry] = useState([])
  const [brandedProductItems, setBrandedProductItems] = useState([])
  const [genericProductItems, setGenericProductItems] = useState([])
  const [ProductQuantity, setProductQuantity] = useState("")
  const [ProductScheme, setProductScheme] = useState("")
  var batch = db.batch()
  const [tabIndex, setTabIndex] = useState(0);

  const [inputValue, setInputValue] = useState('');
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [isTimeDisabled, setIsTimeDisabled] = useState(false);

  useEffect(() => {
    const checkTime = () => {
      const now = new Date();
      const currentHours = now.getHours();
      const currentMinutes = now.getMinutes();
      const isInDisabledTime = (currentHours === 16 && currentMinutes >= 0) || (currentHours > 16 && currentHours < 24);
      setIsTimeDisabled(isInDisabledTime);
    };

    checkTime();
    const timer = setInterval(checkTime, 60000);

    return () => clearInterval(timer);
  }, []);

  const loadPersistedData = async () => {
    const uniqueData = await loadAllMedicine();
    setBrandedProductItems(uniqueData);
    setGenericProductItems(uniqueData);
  };

  useEffect(async () => {
    try {
      loadPersistedData();
    } catch (error) {
      console.log('Error Occur in Get Products And Sales', error)
    }
  }, [])

  const onSubmit = async (data) => {
    console.log('on Tap Submit')
  }

  const handlePreviewSubmit = () => {
    handleSubmit(async (data) => {
      var newSupplyOrder = {}
      newSupplyOrder.userId = userData.uid
      newSupplyOrder.ProductEntry = ProductEntry
      setPreviewState(newSupplyOrder)
      setIsPreview(true)
    })()
  }

  const handleSaveSubmit = () => {
    handleSubmit(async (data) => {
      if (isTimeDisabled) {
        setNotificationMessage('Create Order Portal is closed for Day(04:00PM to 12:00PM), Please try next day!!');
        setOpenNotify(true);
        setAlertType('error');
      } else {
        if (selectedItems && selectedItems?.length > 0) {
          setIsLoading(true)
          let newSupplyOrders = selectedItems?.map(function (obj) {
            const uniqueId = uuidv4();
            var newObj = {}

            newObj.userId = userData.uid;
            newObj.uniqueId = uniqueId;
            newObj.IsAvailable = false;
            newObj.ChemistInfo = userData?.storeName ? `${userData?.storeName} ${userData?.storeAddress}` : userData?.name;
            newObj.SuggestedPrice = 0;
            newObj.ProductName = obj?.ProductName ? obj.ProductName : null;
            newObj.MedicineType = obj?.MedicineType ? obj.MedicineType : null;
            newObj.PackagingSize = obj?.PackagingSize ? obj.PackagingSize : null;
            newObj.ProductScheme = obj?.ProductScheme ? obj.ProductScheme : null;
            newObj.ProductQuantity = obj?.ProductQuantity ? obj.ProductQuantity : null;
            newObj.SupplyOrderPostedDateTime = new Date();

            return newObj;
          });
          try {
            await newSupplyOrders?.map(async (doc) => {
              const collectionRef = await db.collection('SupplyOrder').doc();
              batch.set(collectionRef, doc);
            });
            batch.commit().then(() => {
              setNotificationMessage('Order Created successfully.')
              setOpenNotify(true)
              setAlertType('success')
              reset()
              setIsLoading(false)
              setTimeout(routeToPages, 2000)
            }).catch((error) => {
              console.error(error);
              setNotificationMessage('Something went wrong, Please try again later!!');
              setOpenNotify(true);
              setAlertType('error');
              setIsLoading(false);
              history.push('/chemist/create-order');
            });
          } catch (error) {
            console.error(error)
            setNotificationMessage('Something went wrong, Please try again later!!')
            setOpenNotify(true)
            setAlertType('error')
            setIsLoading(false)
            history.push('/chemist/create-order')
          }
        } else {
          setNotificationMessage('Please Add Product for Order!!')
          setOpenNotify(true)
          setAlertType('error')
          setIsLoading(false)
        }
      }
    })()
  }

  const handleDisabledSaveSubmit = () => {
    handleSubmit(async (data) => {
      setNotificationMessage('Sorry we are not processing order right now, Please try again later!!');
      setOpenNotify(true);
      setAlertType('error');
      setIsLoading(false);
    })()
  }

  const editPreview = () => {
    setIsPreview(false)
    setTimeout(() => {
      mapValues(previewState, (value, key) => setValue(key, value))
    })
  }

  const routeToPages = () => {
    history.push('/chemist/order')
  }

  const onTapAddProductButton = () => {
    if (inputValue && ProductQuantity != "") {
      let item = tabIndex == 0 ? brandedProductItems?.find(s => s.ProductName.toLowerCase() === inputValue.toLowerCase()) : genericProductItems?.find(s => s.ProductName.toLowerCase() === inputValue.toLowerCase());
      if (!item) {
        item = { _id: tabIndex == 0 ? brandedProductItems.length + 1 : genericProductItems?.length + 1, ProductName: inputValue, ProductQuantity, ProductScheme, MedicineType: tabIndex == 0 ? 'Branded' : 'Generic' };
        tabIndex == 0 ? setBrandedProductItems([...brandedProductItems, item]) : setGenericProductItems([...genericProductItems, item]);
      }
      setSelectedItems([...selectedItems, { ...item, ProductQuantity, ProductScheme, MedicineType: tabIndex == 0 ? 'Branded' : 'Generic' }]);

      setInputValue('');
      setProductScheme('');
      setProductQuantity(0);
      setFilteredSuggestions([]); // Clear suggestions
    } else {
      setNotificationMessage('Please Search Medication and add Product Quantity!');
      setOpenNotify(true);
      setAlertType('error');
    }
  }

  // Handle suggestion click (only set inputValue, do not add to selected items)
  const handleSuggestionClick = (suggestion) => {
    setInputValue(suggestion?.ProductName);
    setProductScheme(suggestion?.ProductScheme);
    setFilteredSuggestions([]); // Hide suggestions after selecting one
  };

  // Delete item from selectedItems
  const handleDeleteItem = (_id) => {
    setSelectedItems(selectedItems.filter(item => item._id !== _id));
  };

  // Handle input change and filter suggestions
  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    debouncedFilter(value);
  };
  
    // Debounced function to filter suggestions (delay of 300ms)
    const debouncedFilter = useMemo(
      () =>
        debounce((value) => {
          if (!value) {
            setFilteredSuggestions([]);
            return;
          }
  
          const dataToFilter = tabIndex === 0 ? brandedProductItems : genericProductItems;
          const filtered = dataToFilter
            ?.filter((productItem) =>
              productItem?.ProductName.toLowerCase().includes(value.toLowerCase())
            )
            .slice(0, 10); // Limit to top 10 results
  
          setFilteredSuggestions(filtered);
        }, 300), // Adjust delay as needed
      [brandedProductItems, genericProductItems, tabIndex]
    );

  return (
    <>
      <div className="backButton supplyBackButton">
        <div className="inline__block">
          <Button
            onClick={isPreview ? () => { } : history.goBack}
            color="error"
            variant='outlined'
            className="registerEmp__btnRemove">
            <ArrowBackIcon />&nbsp; {'Go Back'}
          </Button>
        </div>
      </div>
      <div className="createProduct create-order mt-2">
        <Helmet>
          <meta name="description" content="Creating New Sales Bill page." />
          <title>Create New Sales Bill Record | Kaipsool Pharmatech</title>
        </Helmet>
        <Paper className={fixedHeightPaper}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              {!isPreview && (
                <>
                  <h5 className="mt-1 mb-4">Medicine Details:</h5>
                  <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
                    <TabList>
                      <Tab>Branded</Tab>
                      <Tab>Generic</Tab>
                    </TabList>
                    <TabPanel>
                      <div className="branded-tab mt-4">
                        <div className="row mb-3 row--col--md--12">
                          <div className="col-md-5 mb-2 searchOrAdd">
                            <label>Search or Add Medicine</label>
                            <input
                              type="text"
                              className={classNames(
                                'form-control registerEmp__textbox',
                              )}
                              value={inputValue}
                              onChange={handleInputChange}
                              placeholder="Enter Name of the medicines..."
                            />

                            {/* Popup dropdown styling for suggestions */}
                            {filteredSuggestions.length > 0 && (
                              <ul>
                                {filteredSuggestions.map((suggestion) => (
                                  <li
                                    key={suggestion._id}
                                    onClick={() => handleSuggestionClick(suggestion)}
                                    style={{ padding: '8px', cursor: 'pointer', color: '#333', borderBottom: 'solid 1px #000' }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                                  >
                                    {suggestion.ProductName}
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>
                          <div className="col-md-3 mb-2">
                            <label>Scheme (Optional)</label>
                            <input
                              type="text"
                              className={classNames(
                                'form-control registerEmp__textbox',
                              )}
                              placeholder="Scheme"
                              name="ProductScheme"
                              autoComplete="none"
                              value={ProductScheme}
                              onChange={(event) =>
                                setProductScheme(event.target.value)
                              }
                              ref={register()}
                            />
                          </div>
                          <div className="col-md-3 mb-2">
                            <label>Quantity</label>
                            <input
                              type="text"
                              className={classNames(
                                'form-control registerEmp__textbox',
                              )}
                              placeholder="Product Quantity"
                              name="ProductQuantity"
                              autoComplete="none"
                              value={ProductQuantity}
                              onChange={(event) =>
                                setProductQuantity(event.target.value)
                              }
                              required
                              ref={register()}
                            />
                          </div>
                          <div className="col-md-1 mb-2">
                            <label>{' '}</label>
                            <div className="addBox">
                              <Button
                                onClick={onTapAddProductButton}
                                variant="contained"
                                className="registerEmp__btnLogin jsmAdd"
                              >
                                {'Add'}
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div className="generic-tab mt-4">
                        <div className="row mb-3 row--col--md--12">
                          <div className="col-md-5 mb-2 searchOrAdd">
                            <label>Search or Add Medicine</label>
                            <input
                              type="text"
                              className={classNames(
                                'form-control registerEmp__textbox',
                              )}
                              value={inputValue}
                              onChange={handleInputChange}
                              placeholder="Enter Name of the medicines..."
                            />

                            {/* Popup dropdown styling for suggestions */}
                            {filteredSuggestions.length > 0 && (
                              <ul>
                                {filteredSuggestions.map((suggestion) => (
                                  <li
                                    key={suggestion._id}
                                    onClick={() => handleSuggestionClick(suggestion)}
                                    style={{ padding: '8px', cursor: 'pointer', color: '#333', borderBottom: 'solid 1px #000' }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                                  >
                                    {suggestion.ProductName}
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>
                          <div className="col-md-3 mb-2">
                            <label>Scheme (Optional)</label>
                            <input
                              type="text"
                              className={classNames(
                                'form-control registerEmp__textbox',
                              )}
                              placeholder="Scheme"
                              name="ProductScheme"
                              autoComplete="none"
                              value={ProductScheme}
                              onChange={(event) =>
                                setProductScheme(event.target.value)
                              }
                              ref={register()}
                            />
                          </div>
                          <div className="col-md-3 mb-2">
                            <label>Quantity</label>
                            <input
                              type="text"
                              className={classNames(
                                'form-control registerEmp__textbox',
                              )}
                              placeholder="Product Quantity"
                              name="ProductQuantity"
                              autoComplete="none"
                              value={ProductQuantity}
                              onChange={(event) =>
                                setProductQuantity(event.target.value)
                              }
                              required
                              ref={register()}
                            />
                          </div>
                          <div className="col-md-1 mb-2">
                            <label>{' '}</label>
                            <div className="addBox">
                              <Button
                                onClick={onTapAddProductButton}
                                variant="contained"
                                className="registerEmp__btnLogin jsmAdd"
                              >
                                {'Add'}
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                  </Tabs>
                  {selectedItems &&
                    selectedItems.length > 0 &&
                    selectedItems?.filter(item => item.MedicineType == (tabIndex == 0 ? 'Branded' : 'Generic'))?.length > 0 && (<table className="table">
                      <thead>
                        <td>S.No</td>
                        <td>Product</td>
                        <td>Scheme</td>
                        <td>Quantity</td>
                        <td>Action</td>
                      </thead>
                      <tbody>
                        {selectedItems?.filter(item => item.MedicineType == (tabIndex == 0 ? 'Branded' : 'Generic'))?.map((item, index) => {
                          return (
                            <tr key={item._id}>
                              <td>{index + 1}</td>
                              <td>{item?.ProductName}</td>
                              <td>{item?.ProductScheme}</td>
                              <td>{item?.ProductQuantity}</td>
                              <td className="deleteCursor">
                                <DeleteIcon onClick={() => handleDeleteItem(item._id)} />
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>)}
                </>
              )}
              {isPreview && (
                <div className="col-md-12">
                  <div className="backButton">
                    <div className="inline__block">
                      <Button
                        onClick={() => editPreview()}
                        color="error"
                        variant="outlined"
                        className="registerEmp__btnRemove"
                      >
                        <EditIcon />
                        &nbsp; {'Edit'}
                      </Button>
                    </div>
                  </div>

                  <table className="table mt-5">
                    <tr>
                      <td>
                        <h5 className="card-events-title product__mainTitle">
                          {userData.storeName}
                        </h5>
                        {
                          <p className="card-events-title">
                            <b>{userData.storeAddress}</b>
                          </p>
                        }
                        {
                          <p className="card-events-title">
                            Contact No: <b>{userData.phoneNumber}</b>
                          </p>
                        }
                        {
                          <p className="card-events-title">
                            Email Id: <b>{userData.email}</b>
                          </p>
                        }
                        {
                          <p className="card-events-title">
                            GST No: <b>{userData.gstNo}</b>
                          </p>
                        }
                        {
                          <p className="card-events-title">
                            DL No: <b>{userData.drugLicense}</b>
                          </p>
                        }
                      </td>
                    </tr>
                  </table>
                  <Tabs>
                    <TabList>
                      <Tab>Branded</Tab>
                      <Tab>Generic</Tab>
                    </TabList>
                    <TabPanel>
                      <table className="table">
                        <thead>
                          <td>S.No</td>
                          <td>Product</td>
                          <td>Scheme</td>
                          <td>Quantity</td>
                        </thead>
                        <tbody>
                          {selectedItems &&
                            selectedItems?.length > 0 &&
                            selectedItems?.filter(item => item.MedicineType == 'Branded')?.map((item, index) => {
                              return (
                                <tr>
                                  <td>{index + 1}</td>
                                  <td>{item?.ProductName}</td>
                                  <td>{item?.ProductScheme}</td>
                                  <td>{item?.ProductQuantity}</td>
                                </tr>
                              )
                            })}
                        </tbody>
                      </table>
                    </TabPanel>
                    <TabPanel>
                      <table className="table">
                        <thead>
                          <td>S.No</td>
                          <td>Product</td>
                          <td>Scheme</td>
                          <td>Quantity</td>
                        </thead>
                        <tbody>
                          {selectedItems &&
                            selectedItems?.length > 0 &&
                            selectedItems?.filter(item => item.MedicineType == 'Generic')?.map((item, index) => {
                              return (
                                <tr>
                                  <td>{index + 1}</td>
                                  <td>{item?.ProductName}</td>
                                  <td>{item?.ProductScheme}</td>
                                  <td>{item?.ProductQuantity}</td>
                                </tr>
                              )
                            })}
                        </tbody>
                      </table>
                    </TabPanel>
                  </Tabs>
                </div>
              )}
              <div className="col-sm-12 text-right mt-2">
                <div className="d-flex justify-content-center">
                  {!isPreview && (
                    <div className="p-2">
                      <Button
                        type="submit"
                        name="preview"
                        value="preview"
                        variant="contained"
                        onClick={handlePreviewSubmit}
                        className="registerEmp__btnLogin preview"
                      >
                        {'Preview'}
                      </Button>
                    </div>
                  )}
                  {isPreview && (
                    <div className="p-2">
                      <Button
                        type="submit"
                        name="saved"
                        value="saved"
                        variant="contained"
                        disabled={isLoading ? true : false}
                        onClick={handleSaveSubmit}
                        // onClick={handleDisabledSaveSubmit}
                        className="registerEmp__btnLogin save"
                      >
                        {isLoading ? <CircularProgress size={18} /> : 'Place Order'}
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </form>
        </Paper>
      </div>
      <CustomAlert
        setOpenNotify={setOpenNotify}
        openNotify={openNotify}
        messageType={alertType}
        notificationMessage={notificationMessage}
      />
    </>
  )
}

export default CreateChemistOrder
